
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7b24a912&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SeckillApp.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SeckillApp.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7b24a912!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SeckillApp.vue"),
  /* scopeId */
  "data-v-7b24a912",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/activity/SeckillApp.vue
// module id = 980
// module chunks = 2